import { apiClient } from 'lib/api';
import { queryOptions } from '@tanstack/react-query';
import type { Rule, RulesListParams } from '../types';
import type { GetRulesListPromise } from '../../types';
import type { QueryFnContext } from 'lib/react-query';

const getRulesList = async ({
  queryKey,
  signal,
}: QueryFnContext<Partial<RulesListParams>>): Promise<GetRulesListPromise<Rule>> => {
  const params = queryKey[1];

  const res = await apiClient.get<GetRulesListPromise<Rule>>(`/rules`, {
    params,
    signal,
  });

  return res.data;
};

export const FB_RULES_LIST_KEY = '/rules';

export const getRulesListOptions = (params: Partial<RulesListParams>) =>
  queryOptions({
    queryFn: getRulesList,
    queryKey: [FB_RULES_LIST_KEY, params],
    staleTime: 60 * 30 * 1000,
  });
